import React from 'react'
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.primary.main
    },
    marginTop: {
        marginTop: theme.spacing(2)
    }

}));


const HelpPopUp = (props) => {
    const classes = useStyles()
    const { onClose, isOpen } = props
    return (
        <Dialog
            maxWidth="xs"
            open={isOpen}
            onClose={onClose}
            aria-labelledby="Customer Support Pop Up"
            aria-describedby="Customer Support Pop Up"
        >
            <DialogTitle>
                <Typography component="p" variant="body1" align="center" color="primary">
                    <strong>Customer Support</strong>
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Grid container>
                    <Grid item xs={10} style={{ margin: '0 auto' }}>
                        <Typography component="p" variant="body2" align="center" color="primary">
                            Our customer experience team is available all days from 8:00 am to 11:30 pm to assist you with any questions or issues you might have.
                         </Typography>

                        <div className={classes.marginTop}>
                            <Typography component="p" variant="body2" align="center" color="primary">
                                <strong>EMAIL US</strong>
                            </Typography>
                            <Typography component="p" variant="body2" align="center" color="primary">
                                <a className={classes.link} href="mailto:operations@desicooks.in?subject=support" >operations@desicooks.in</a>
                            </Typography>
                        </div>

                        <div className={classes.marginTop}>
                            <Typography component="p" variant="body2" align="center" color="primary">
                                <strong>CALL US</strong>
                            </Typography>
                            <Typography component="p" variant="body2" align="center" color="primary">
                                <a className={classes.link} href="tel:97807 97807" >97807 97807</a>
                            </Typography>
                        </div>
                    </Grid>
                </Grid>

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )

}

export default HelpPopUp